module.exports = __webpack_public_path__ + "static/media/sports.c91c8398.jpeg";